import { render, staticRenderFns } from "./doctor_taskBox.vue?vue&type=template&id=7d76a1d0&scoped=true&"
import script from "./doctor_taskBox.vue?vue&type=script&lang=js&"
export * from "./doctor_taskBox.vue?vue&type=script&lang=js&"
import style0 from "./doctor_taskBox.vue?vue&type=style&index=0&id=7d76a1d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d76a1d0",
  null
  
)

export default component.exports